import { getLiveClasses, addLiveClass } from '../live-classes';
import { exportActivities } from './index';

const exportLiveClasses = data => {
    return exportActivities({ ...data, getter: getLiveClasses, adder: addLiveClass, dateField: 'startDateTime' });
};

export default exportLiveClasses;
